type AxiosLikeError = {
  response?: { data?: { message?: string } };
  message?: string;
};

/** Parse legacy Meta Graph errors returned as JSON strings in API `message`. */
function humanizeMetaOAuthJson(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed.startsWith('{')) return null;
  try {
    const parsed = JSON.parse(trimmed) as {
      error?: { message?: string; code?: number; type?: string };
    };
    const code = parsed?.error?.code;
    const msg = parsed?.error?.message?.trim();
    if (code === 190) {
      return (
        'WhatsApp access token is invalid or expired (Meta error 190). ' +
        'Update the token under Hospital Admin → Mini CRM → WhatsApp numbers, ' +
        'or ask your admin to refresh WA_CLOUD_API_ACCESS_TOKEN on the server.'
      );
    }
    if (msg) return msg;
  } catch {
    /* not JSON */
  }
  return null;
}

/** Best-effort user-facing message from axios-style API errors. */
export function getApiErrorMessage(err: unknown, fallback: string): string {
  const ax = err as AxiosLikeError;
  const raw = ax.response?.data?.message?.trim();
  if (raw) {
    return humanizeMetaOAuthJson(raw) ?? raw;
  }
  const direct = ax.message?.trim();
  if (direct) return humanizeMetaOAuthJson(direct) ?? direct;
  return fallback;
}
